import { shopId } from "../config/const";
import { callFetch, idTokenHeader, tokenHeader } from "./utils";

const EndPoint = {
  ApplyCoupon: (lineId) => `/linewebhook/coupon/shop/${shopId}/${lineId}`,
  AddCouponBucket: (lineId) => `/linewebhook/coupon/shop/${shopId}/add-bucket/${lineId}`,
};

export function addCouponBucket(lineId, idToken, code = "") {
  const uri = EndPoint.AddCouponBucket(lineId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ code }),
  };

  return callFetch(uri, settings);
}

export function applyCoupon(lineId, idToken, couponLinkId) {
  const uri = EndPoint.ApplyCoupon(lineId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ couponLinkId }),
  };

  return callFetch(uri, settings);
}
